import { Component, Input } from '@angular/core';
import { AggregatedJobData } from '@shared';

@Component({
  selector: 'mojo-dashboard-total-matches-numbers',
  styleUrls: ['./dashboard-total-matches-numbers.component.scss'],
  templateUrl: './dashboard-total-matches-numbers.component.html',
})
export class DashboardTotalMatchesNumbersComponent {
  @Input() aggregatedJobData: AggregatedJobData;
}
